import './assets/ripple.css';

/**
 * https://github.com/PygmySlowLoris/vue-ripple-directive
 * 快捷指令在DOM元素上添加点击水波纹效果
 * 使用方法: v-ripple 或 v-ripple="'rgba(0,0,0,0.15)'" 或 v-ripple.500="'rgba(0,0,0,0.15)'"
 * 注意: 时长最大值为1000毫秒, 颜色值为字符串;
 */

export default {
	bind (el: HTMLElement, binding: any) {
		let transition: number = 600;

		Object.keys(binding.modifiers).forEach(item => {
			if (/^\d+$/g.test(item)) {
				transition = +item > 1000 ? 1000 : +item;
			}
		});

		el.addEventListener('mousedown', function (event: any){
			rippler(event, el);
		});

		var bg = binding.value || 'rgba(0, 0, 0, 0.15)';
		var zIndex = '9999';

		function rippler (event: MouseEvent, el: HTMLElement){
			var target = el;
			// Get border to avoid offsetting on ripple container position
			var targetBorder = parseInt((getComputedStyle(target) as any).borderWidth.replace('px', ''));

			// Get necessary variables
			var rect = target.getBoundingClientRect(),
				left = rect.left,
				top = rect.top,
				width = target.offsetWidth,
				height = target.offsetHeight,
				dx = event.clientX - left,
				dy = event.clientY - top,
				maxX = Math.max(dx, width - dx),
				maxY = Math.max(dy, height - dy),
				style = window.getComputedStyle(target),
				radius = Math.sqrt(maxX * maxX + maxY * maxY),
				border = targetBorder > 0 ? targetBorder : 0;

			// Create the ripple and its container
			var ripple = document.createElement('div'),
				rippleContainer = document.createElement('div');
			rippleContainer.className = 'ripple-container';
			ripple.className = 'ripple';

			//Styles for ripple
			ripple.style.marginTop = '0px';
			ripple.style.marginLeft = '0px';
			ripple.style.width = '1px';
			ripple.style.height = '1px';
			ripple.style.transition = 'all ' + transition + 'ms cubic-bezier(0.4, 0, 0.2, 1)';
			ripple.style.borderRadius = '50%';
			ripple.style.pointerEvents = 'none';
			ripple.style.position = 'relative';
			ripple.style.zIndex = zIndex;
			ripple.style.backgroundColor = bg;

			//Styles for rippleContainer
			rippleContainer.style.position = 'absolute';
			rippleContainer.style.left = 0 - border + 'px';
			rippleContainer.style.top = 0 - border + 'px';
			rippleContainer.style.height = '0';
			rippleContainer.style.width = '0';
			rippleContainer.style.pointerEvents = 'none';
			rippleContainer.style.overflow = 'hidden';

			// Store target position to change it after
			var storedTargetPosition =
				(target as any).style.position.length > 0 ? target.style.position : getComputedStyle(target).position;
			// Change target position to relative to guarantee ripples correct positioning
			if (storedTargetPosition !== 'relative') {
				target.style.position = 'relative';
			}

			rippleContainer.appendChild(ripple);
			target.appendChild(rippleContainer);

			ripple.style.marginLeft = dx + 'px';
			ripple.style.marginTop = dy + 'px';

			// No need to set positioning because ripple should be child of target and to it's relative position.
			// rippleContainer.style.left    = left + (((window.pageXOffset || document.scrollLeft) - (document.clientLeft || 0)) || 0) + "px";
			// rippleContainer.style.top     = top + (((window.pageYOffset || document.scrollTop) - (document.clientTop || 0)) || 0) + "px";
			rippleContainer.style.width = width + 'px';
			rippleContainer.style.height = height + 'px';
			rippleContainer.style.borderTopLeftRadius = style.borderTopLeftRadius;
			rippleContainer.style.borderTopRightRadius = style.borderTopRightRadius;
			rippleContainer.style.borderBottomLeftRadius = style.borderBottomLeftRadius;
			rippleContainer.style.borderBottomRightRadius = style.borderBottomRightRadius;

			rippleContainer.style.direction = 'ltr';

			setTimeout(function (){
				ripple.style.width = radius * 2 + 'px';
				ripple.style.height = radius * 2 + 'px';
				ripple.style.marginLeft = dx - radius + 'px';
				ripple.style.marginTop = dy - radius + 'px';
			}, 0);

			function clearRipple (){
				setTimeout(function (){
					ripple.style.backgroundColor = 'rgba(0, 0, 0, 0)';
				}, transition + 250);

				// Timeout set to get a smooth removal of the ripple
				setTimeout(function (){
					(rippleContainer as any).parentNode.removeChild(rippleContainer);
				}, transition + 850);

				el.removeEventListener('mouseup', clearRipple, false);

				// After removing event set position to target to it's original one
				// Timeout it's needed to avoid jerky effect of ripple jumping out parent target
				setTimeout(function (){
					var clearPosition = true;
					for (var i = 0; i < target.childNodes.length; i++) {
						if ((target.childNodes[i] as any).className === 'ripple-container') {
							clearPosition = false;
						}
					}

					if (clearPosition) {
						if (storedTargetPosition !== 'static') {
							target.style.position = storedTargetPosition;
						} else {
							target.style.position = '';
						}
					}
				}, transition + 250);
			}

			el.addEventListener('mouseup', clearRipple, false);
		}
	},
};
